import { GraphicElementApi } from '@/types/GraphicElement';
import Layer, { GroupLayer } from '@/types/Layer';
import { GraphicElementMapper } from './GraphicElementMapper';

export class LayerMapper {
    static getLayerFromElement(graphicElement: GraphicElementApi): Layer | GroupLayer {
        const { uuid, type, visible } = graphicElement;
        const elementOptions = (graphicElement as any).options || {};
        // VDP (publipostage) : un Text portant options.vdp.enabled est un « Texte
        // variable » — il DOIT être identifié comme tel (sinon il apparaît comme un
        // texte simple et sa ré-édition ouvre le mauvais formulaire, perdant la liste).
        const isVariableText = elementOptions?.vdp?.enabled === true;
        const layer: Layer | GroupLayer = {
            id: uuid,
            typeId: isVariableText ? 'variableText' : this.getType(type) || 'text',
            content: GraphicElementMapper.getContentByType(graphicElement),
            visible: visible,
            isLocked: graphicElement.isLocked || false,
            // Preserve les options (fontFamily, fill, themeTag, themeName, name
            // pour QR/shape/clipart, etc.) — sinon la LayerBar n'a aucun moyen
            // de regrouper les enfants d'un theme ni d'identifier les types
            // custom (QR, shape, clipart) dans LayerChip.displayType.
            options: (graphicElement as any).options || {},
            // Propage la zone d'appartenance (multi-zones). Permet a la
            // LayerBar de filtrer reactivement par zone selectionnee, sans
            // dependre de la presence physique de l'objet sur le canvas
            // de zone (qui peut etre temporairement vide pendant un load).
            zoneId: (graphicElement as any).zoneId ?? null,
            canvasMeshId: (graphicElement as any).canvasMeshId ?? null
        };

        if (Array.isArray(graphicElement.colorGroups)) {
            // Defensif : certains CustomGraphicElement arrivent avec des
            // colorGroups incomplets (ex. sans .color → shape plate ou data
            // partielle). On tolere plusieurs shapes et on filtre les
            // entrees sans hex valide plutot que de casser le mapping du
            // layer (ce qui remonte jusqu'au store et bloque la LayerBar).
            //@ts-ignore
            layer.colors = graphicElement.colorGroups
                .map((colorGroup: any) => {
                    const hex =
                        colorGroup?.color?.hexaValue ??
                        colorGroup?.color?._hexaValue ??
                        colorGroup?.hexaValue ??
                        colorGroup?._hexaValue;
                    if (typeof hex !== 'string') {
                        return null;
                    }
                    return { hexaValue: hex, id: colorGroup.id };
                })
                .filter((c: any) => c !== null);
        }

        return layer;
    }

    static getType(type: string) {
        if (String(type ?? '').toLowerCase() === 'customgraphicelement') {
            return 'group';
        }
        return type?.toLowerCase();
    }
}
